/**
 * Représente le paramétrage des vues d'un profil.
 */
export class ProfileViewSettings {
    /**
     * Nombre de groupes de sections.
     */
    public sectionsGroupsCount: number;

    /**
     * Identifiant de la mise en page par défaut de la vue.
     */
    public defaultViewLayout?: number;

    /**
     * Identifiant du filtre prédéfini par défaut de la vue.
     */
    public defaultViewPredefinedFilter?: number;

    /**
     * Crée une copie de l'instance de ProfileViewSettings.
     * @returns : Instance de ProfileViewSettings.
     */
    public createCopy(): ProfileViewSettings {
        const instance = new ProfileViewSettings();
        instance.sectionsGroupsCount = this.sectionsGroupsCount;
        instance.defaultViewLayout = this.defaultViewLayout;
        instance.defaultViewPredefinedFilter = this.defaultViewPredefinedFilter;

        return instance;
    }

    /**
     * Retourne une instance de ProfileViewSettings à partir d'une instance non typée de ProfileViewSettings.
     * @param other : Instance non typée de ProfileViewSettings.
     * @returns : Instance typée de ProfileViewSettings.
     */
    public static from(other: ProfileViewSettings) {
        if (!!other) {
            const instance = new ProfileViewSettings();

            instance.defaultViewLayout = other.defaultViewLayout;
            instance.defaultViewPredefinedFilter = other.defaultViewPredefinedFilter;
            instance.sectionsGroupsCount = other.sectionsGroupsCount;

            return instance;
        } else {
            return null;
        }
    }
}
